import { ActionType } from '../../constants/ActionTypes'

export default function settingsReducer(state = {}, action = {}) {
    switch (action.type) {

        case ActionType.GET_SETTINGS_BEGIN:
            const isLoading = action.payload ? { isLoading: true } : {}
            return {
                ...state,
                ...isLoading
            }
        case ActionType.GET_SETTINGS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ...action.payload
            }
        case ActionType.GET_SETTINGS_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case ActionType.GET_CITIES_BEGIN:
        case ActionType.GET_REGIONS_BEGIN:
        case ActionType.GET_COUNTRIES_BEGIN:
            return {
                ...state,
                cities: []
            }
        case ActionType.GET_COUNTRIES_SUCCESS:
            return {
                ...state,
                countries: action.payload
            }
        case ActionType.GET_CITIES_SUCCESS:
            return {
                ...state,
                cities: action.payload
            }
        case ActionType.GET_REGIONS_SUCCESS:
            return {
                ...state,
                regions: action.payload
            }
        case ActionType.GET_NSEP_BEGIN:
            return {
                ...state,
                nsep: ''
            }
        case ActionType.GET_NSEP_SUCCESS:
            return {
                ...state,
                nsep: action.payload
            }
        case ActionType.GET_NSEP_ERROR:
            return {
                ...state,
                error: action.payload
            }
        case ActionType.UPDATE_LOGO:
            return {
                ...state,
                logo: {
                    ...state.logo,
                    [action.payload.type]: {
                        ...state.logo[action.payload.type],
                        value: action.payload.value
                    }
                }
            }
        case ActionType.GET_PROFILE_SETTINGS_BEGIN:
        case ActionType.GET_REGISTRATION_SETTINGS_BEGIN:
            return {
                ...state,
                genders: [],
                countries: [],
                cities: null,
                regions: null
            }
        case ActionType.GET_CITIES_ERROR:
        case ActionType.GET_REGIONS_ERROR:
        case ActionType.GET_PROFILE_SETTINGS_ERROR:
        case ActionType.GET_REGISTRATION_SETTINGS_ERROR:
        case ActionType.GET_LOGIN_SETTINGS_ERROR:
            return {
                ...state,
                error: action.payload
            }
        case ActionType.GET_PROFILE_SETTINGS_SUCCESS:
        case ActionType.GET_LOGIN_SETTINGS_SUCCESS:
        case ActionType.GET_REGISTRATION_SETTINGS_SUCCESS:
            return {
                ...state,
                ...action.payload
            }
        case ActionType.GET_SPORT_BEGIN:
            return {
                ...state,
                sportToken: {}
            }
        case ActionType.GET_SPORT_ERROR:
            return {
                ...state,
                sportToken: {},
                error: action.payload
            }
        case ActionType.GET_SPORT_SUCCESS:
            return {
                ...state,
                sportToken: action.payload
            }
        case ActionType.OPEN_SPORT_BET_HISTORY:
            return {
                ...state,
                openSportBetHistory: isNaN(state.openSportBetHistory) ? 0 : ++{ ...state }.openSportBetHistory
            }
        case ActionType.SET_DEMO_MODE:
            return {
                ...state,
                demoMode: action.payload
            }
        case ActionType.SET_COLOR_MODE:
            return {
                ...state,
                uiSettingMode: action.payload
            }
        case ActionType.SET_POPUPS_COLOR_MODE:
            return {
                ...state,
                popUpsColorMode: action.payload
            }
        case ActionType.SET_CURRENCY_ID:
            return {
                ...state,
                currencyId: action.payload
            }
        case ActionType.GET_REACH_LIMIT:
            return {
                ...state,
                isReachLimitPopupOpen: action.payload.isReachLimitPopupOpen,
                reachLimitData: action.payload.reachLimitData
            }
        case ActionType.GET_UNVERIFIED_USER_REMINDER:
            return {
                ...state,
                isUnverifiedUserReminderOpen: action.payload.isUnverifiedUserReminderOpen
            }
        default:
            return state;
    }

}

